import { usPlanData } from 'src/constants/planData/usPlanData'
import { PlanCards } from '../PlanCards'
import { useFormatFanduelData } from 'src/modules/hooks/useFormatFanduelData'
import { RSNS_BY_SPORT_TYPE } from 'src/constants/planData'

const FanduelPlanCards = ({
  title,
  subtitle,
  rsnData,
  showFanduelWithPro = true,
  lang,
  market,
  sportType,
}) => {
  const fanduelPlan = useFormatFanduelData(usPlanData.fanduel_standalone_monthly, rsnData)

  const pro_rsns = sportType
    ? RSNS_BY_SPORT_TYPE[sportType]
    : usPlanData.pro_standalone_monthly.networkLogos

  return (
    <PlanCards
      title={title}
      subtitle={subtitle}
      lang={lang}
      market={market}
      plans={
        showFanduelWithPro
          ? [fanduelPlan, { ...usPlanData.pro_standalone_monthly, networkLogos: pro_rsns }]
          : [fanduelPlan]
      }
      sharedData={{
        rsn: rsnData.rsn,
        teams: rsnData.teams,
      }}
    />
  )
}

export default FanduelPlanCards
